<template lang="pug">
div
  UiCardSection
    UiStack
      UiStackItem(fill)
        .ui-card-section-title {{ $t("resellers.tabs.statistics") }}
  UiCardSection
    RestTable(
      namespace="resellerStatistics"
      :headers="headers"
      ref="resellerStatisticsTable"
      :fetch-handler="getData"
      :disable-pagination="true"
      embed
    )
</template>

<script>
import router from "@/router";
import ApiResellers from "@/api/resellers.js";

export default {
  data() {
    return {
      headers: [
        {
          key: "method",
          label: "Method",
          sortable: false,
        },
        {
          key: "total",
          label: "Suggestions",
          sortable: false,
        },
        {
          key: "true",
          label: "True",
          sortable: false,
        },
        {
          key: "false",
          label: "False",
          sortable: false,
        },
        {
          key: "rate",
          label: "Rate",
          sortable: false,
        },
      ],
    };
  },

  methods: {
    getData(params, config) {
      return ApiResellers.fetchResellerStatistics(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.reseller_statistics,
          meta: resp.data.meta,
        };
      });
    },
    goBack() {
      router.push("/resellers");
    },
  },
};
</script>
